import { connect } from 'react-redux'

import {
  search,
  deleteWopi,
  setShowOnlyOwnQuestionnaires,
  setNewInvitationWopis
} from '../../ducks/questionnaire-admin'
import WopiList from '../WopiList'

export default connect(
  state => ({
    currentLanguage: state.account.get('currentLanguage'),
    questionnaireUuid: state.questionnaireAdmin.get('questionnaireUuid'),
    questionnaires: state.questionnaireAdmin.get('questionnaires'),
    deletedWopis: state.questionnaireAdmin.get('deletedWopis'),
    searchFilters: state.questionnaireAdmin.get('searchFilters'),
    pagination: state.questionnaireAdmin.get('pagination'),
    sentInvitations: state.questionnaireAdmin.get('sentInvitations'),
    newInvitationWopis: state.questionnaireAdmin.get('newInvitationWopis'),
    showOnlyOwnQuestionnaires: state.questionnaireAdmin.get('showOnlyOwnQuestionnaires'),
    token: window.localStorage.getItem('token')
  }),
  {
    search,
    deleteWopi,
    setShowOnlyOwnQuestionnaires,
    setNewInvitationWopis
  }
)(WopiList)



// WEBPACK FOOTER //
// ./src/components/smart/WopiListContainer.js